import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Modal } from 'antd';
import isEmpty from 'lodash/isEmpty';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as intentActions from '../../../../../data/redux/intent_details/actions';
import * as nlpActions from '../../../../../data/redux/nlp_details/actions';
import { getPreemptiveData, getWorkFlowData } from '../../../../../data/redux/botbuilder_details/actions';

import { APP_PAGES, PERMISSIONS } from '../../../../../data/config/constants';
import { uniqueId, showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import CustomHeader from '../../../../../components/customheader';
import TableCellAction from '../../../components/tablecellaction';
import ShowMessage from '../../../../../components/showmessage';
import InputItem from '../../../../../components/form/inputitem';
import SwitchItem from '../../../../../components/form/switchitem';
import ModalFooter from '../../../../../components/modalfooter';

class Intents extends Component {
    constructor(props){
        super(props);
        this.state = {
            search_text: "",
            filtered_intents: props.intent_details.intents,
            current_intent: null,
            modal_data: {
                title: "",
                show_create_intent: false,
            }
        };
        this.columns = this.getIntentTableColumns();
    }

    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.INTENTS, APP_PAGES.BOT_BUILDER);
    }

    componentDidMount() {
        const { actions, intent_details } = this.props;
        if (isEmpty(intent_details.intents)) {
            actions.fetchAllIntents();
        }
        actions.getPreemptiveData();
        actions.getWorkFlowData();
        actions.getAllEntities();
    }

    componentWillReceiveProps(nextProps) {
        const { intent_details } = this.props;
        const { search_text } = this.state;
        if (nextProps.intent_details.intents.length !== intent_details.intents.length) {
            const data = [...nextProps.intent_details.intents];
            if (search_text.trim().length !== 0) {
                this.setState({
                    filtered_intents: this.filterIntentBySearchText(search_text, data)
                });
            } else {
                this.setState({
                    filtered_intents: data
                });
            }
        }
    }

    getIntentTableColumns = () => {
        const columns = [
            {
                title: "Intent",
                key: "intent",
                dataIndex: "intent"
            },
            {
                title: "Status",
                key: "status",
                dataIndex: "status",
                render: bool => <span>{bool ? "Active": "Inactive"}</span>
            },
            {
                title: "Event",
                key: "event",
                dataIndex: "event"
            },
            {
                title: "Action",
                key: "action",
                dataIndex: "action",
                render: (text, record) => {
                    return (
                        <TableCellAction show_edit show_delete delete_popconfirm_title="Are you sure delete this intent?" handleEditClick={this.handleEditIntent.bind(this,record)} handleDeleteClick={this.deleteIntent.bind(this,record)} />
                    );
                }
            }
        ];
        return columns;
    };

    filterIntentBySearchText = (text, intents) => {
        return intents.filter((item) => {
            return (item.intent && item.intent !== undefined && item.intent.toLowerCase().indexOf(text.toLowerCase()) !== -1);
        });
    };

    handleIntentSearch = (event) => {
        const search_text = event.target.value;
        const { intent_details } = this.props;

        this.setState({ search_text });
        if (search_text.trim().length !== 0) {
            this.setState({
                filtered_intents: this.filterIntentBySearchText(search_text, intent_details.intents)
            });
        } else {
            this.setState({
                filtered_intents: intent_details.intents
            });
        }
    };

    closeModal = () => {
        this.setState({
            current_intent: null,
            modal_data: {
                title: "",
                show_create_intent: false,
            }
        });
    };

    handleAddIntent = () => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.INTENT, PERMISSIONS.ACTION_TYPES.CREATE)) {
            this.setState({
                current_intent: {
                    intent: "",
                    status: false
                },
                modal_data: {
                    title: "Create Intent",
                    show_create_intent: true,
                }
            });
        } else {
            showMessage('warning', 'You have not permission to create intent.');
        }
    };

    handleEditIntent = (intent) => {
        const { history, match, isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.INTENT, PERMISSIONS.ACTION_TYPES.UPDATE) && intent && intent.intentUniqueId && match && match.path) { 
            const page_url = `${match.path}/${intent.intentUniqueId}`;
            history.push(page_url);
        } else {
            showMessage('warning', 'You have not permission to update intent.');
        }
    };

    createIntent = () => {
        this.props.actions.createIntent(this.state.current_intent,this.closeModal, this.handleEditIntent);
    };

    deleteIntent = (intent) => {
        const { actions, isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.INTENT, PERMISSIONS.ACTION_TYPES.DELETE) && intent && intent.intentUniqueId) {
            const payload = {
                intentUniqueId: intent.intentUniqueId
            };
            actions.deleteIntent(payload);
        } else {
            showMessage('warning', 'You have not permission to delete intent.');
        }
    };

    render() {
        const { page_details, intent_details } = this.props;
        const { filtered_intents, modal_data, current_intent } = this.state;
        const mobile = page_details.device_data.screen_width < 768;

        if (intent_details.loaders.intents_loading && !intent_details.loaders.intents_loaded) {
            return (
                <div className="ori-full-parent-height">
                    <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                    <div className="ori-pad-10">
                        <CardRowTableLoader />
                    </div>
                </div>
            );
        } else if (!intent_details.loaders.intents_loading && intent_details.loaders.intents_loaded) {
            return (
                <div className="ori-lr-pad-10">
                    <CustomHeader title="Intents" first_button_text="+ Add Intent" first_button_type="primary" search_placeholder="Search Intent" onChangeSearch={this.handleIntentSearch} onClickFirstButton={this.handleAddIntent} bottom_bordered show_search show_first_button />
                    <div className="ori-tb-pad-10">
                        <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.columns} dataSource={filtered_intents} />
                    </div>
                    <Modal className="ori-modal-primary" title={modal_data.title} footer={null} maskClosable={false} visible={modal_data.show_create_intent} onCancel={this.closeModal}>
                        {
                            modal_data.show_create_intent &&
                            <div className="ori-pad-15">
                                <InputItem container_class="ori-b-pad-10"  title="Intent Name" placeholder="Enter Intent Name" value={ current_intent.intent } onChange={(e)=>this.setState({current_intent:{...current_intent, intent: e.target.value}})} auto_focus />
                                <SwitchItem title="status" checked={current_intent.status} onChange={(status)=>this.setState({current_intent:{...current_intent, status}})} switch_first />
                                <ModalFooter loading={intent_details.loaders.intent_creating} button_ok_text="Create" capsule_button handleCancelClick={this.closeModal} handleOkClick={this.createIntent} />
                            </div>
                        }
                    </Modal>
                </div>
            );
        } else if (!intent_details.loaders.intents_loading && !intent_details.loaders.intents_loaded) {
            return (
                <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load intent details. please check your internet connection and reload the page." height={150} width={150} />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        intent_details: state.intent_details
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, intentActions, nlpActions, { getPreemptiveData, getWorkFlowData }), dispatch)
    };
}

Intents.propTypes = {
    intent_details: PropTypes.object,
    actions: PropTypes.object,
    page_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Intents);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/intents/index.js